// ─────────────────────────────────────────────────────────────────────────────
// GENERATED FILE — DO NOT EDIT HERE.
//
// Source of truth: invits-app-new/shared/homePaging.js
// Regenerate:     npm run sync:shared   (from invits-app-new)
//
// Editing this copy reintroduces exactly the app/web divergence that shared/
// exists to eliminate. Change the source, then re-run the sync.
// ─────────────────────────────────────────────────────────────────────────────

// shared/homePaging.js
//
// How the home list pages: 6 first, then 4 more at a time.
//
// Six fills a phone screen and a little past it, so the first paint shows a
// full screen of invitations without waiting on more than it can show; four
// per scroll keeps each extra request small enough that reaching the bottom
// never feels like a load.

export const FIRST_PAGE = 6;
export const NEXT_PAGE = 4;

/**
 * The next page to ask for, or undefined when there is nothing left.
 *
 * "Nothing left" is read from a SHORT page — fewer rows back than were asked
 * for — rather than from a total count, so no second query is needed to know
 * when to stop.
 *
 * @param {{rows: object[], limit: number}} lastPage
 * @param {Array<{rows: object[]}>} allPages
 */
export function nextPageParam(lastPage, allPages) {
  if (!lastPage || lastPage.rows.length < lastPage.limit) return undefined;
  const loaded = allPages.reduce((n, p) => n + p.rows.length, 0);
  return { offset: loaded, limit: NEXT_PAGE };
}

/** The first page's parameters. */
export const firstPageParam = { offset: 0, limit: FIRST_PAGE };

/**
 * Upcoming / Past sections from server-ordered rows.
 *
 * The server has already ordered and labelled every row, so this only groups —
 * it never re-sorts. Re-sorting here with the phone's clock could move a row
 * across the Upcoming/Past line between pages and show it twice.
 */
export function sectionsFromRows(rows) {
  const upcoming = [];
  const past = [];
  const seen = new Set();
  for (const row of Array.isArray(rows) ? rows : []) {
    if (!row || seen.has(row.id)) continue;   // a row shifted across a page edge
    seen.add(row.id);
    (row.section === 'past' ? past : upcoming).push(row);
  }
  const sections = [];
  if (upcoming.length) sections.push({ key: 'upcoming', title: 'Upcoming', data: upcoming });
  if (past.length) sections.push({ key: 'past', title: 'Past', data: past });
  return sections;
}
